import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, TextField, Select, FormControl, MenuItem,
    InputLabel, Typography, Button, ButtonGroup, FormControlLabel,
    FormLabel, RadioGroup, Radio
} from "@material-ui/core";
import CustomSwitch from "../../Common/CustomSwitch";
import TimePeriodPicker from '../../Filters/TimePeriodPicker';
import t from "../../../languages/pl";
import { themeTypeToBool } from './../../../utils/helpers';
import ConditionsDialog from '../AutomaticReports/ConditionsDialog';

const useStyles = theme => ({
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        margin: theme.spacing(1),
        marginLeft: theme.spacing(0),
        marginTop: 0
    },
    textfield: {
        margin: theme.spacing(1),
        marginTop: 0,
        width: 150
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    },
    selectFormControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    select: {
        background: "transparent",
        '&:focus': {
            background: "none",
        }
    },
    automaticSwitch: {
        margin: theme.spacing(1),
        paddingTop: theme.spacing(2),
        display: "flex",
        alignItems: "center"
    },
    firstRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginRight: theme.spacing(11),
    },
    buttonLabel: {
        color: "#FFF"
    },
    endRow: {
        justifyContent: "flex-end"
    },
    radio: {
        color: theme.palette.secondary.main
    },
    radioText: {
        color: themeTypeToBool(theme.palette.type) ? "#808495" : "inherit"
    },
    radioSpacing: {
        marginLeft: "auto"
    },
    newReportConditions:{
        paddingLeft: theme.spacing(5),
    }
});


const options = [
    { key: "Dobowym", value: 2 },
    { key: "Tygodniowym", value: 1 },
    { key: "Miesięcznym", value: 0 }
];
const ReportDetails = props => {
    const { classes, autoEnable = false, typeId, reportName, reportFilename, cycle,
        onChange, isEdit = false, onEmailsEdit, startTime, endTime,
         onRadioChange, checkedOption, withCars, withDrivers, isNew, reportConditions,
         onSubmit7TypeId, onSubmit25TypeId, onSubmit26TypeId, onSubmit30TypeId } = props;
    const [isAutomatic, setAutomatic] = useState(false);
    const [inputName, setName] = useState("");
    const [inputFilename, setFilename] = useState("");
    const [selectedTypeId, setSelectedTypeId] = useState(null);
    const [startTimeCondition, setStartTimeCondition] = useState(25200);
    const [endTimeCondition, setEndTimeCondition] = useState(54000);
    const [kilometersLimitCondition, setKilometersLimitCondition] = useState(0);
    const [option, setOption] = useState(1);
    const [fileName, setFileName] = useState("");

    useEffect(() => {
        setName(reportName);
        setFilename(reportFilename);
    }, [reportName, reportFilename]);

    useEffect(() => {
        if (reportConditions) {
            if (typeId === 25 && reportConditions !== null) {
                setStartTimeCondition(parseInt(reportConditions));
            }
            if (typeId === 30 && reportConditions !== null) {
                setKilometersLimitCondition(parseInt(reportConditions));
            }
        }
    }, [reportConditions, typeId]);

    useEffect(() => {
        setOption(checkedOption);
    }, [checkedOption]);

    const handleAutomaticChange = (e) => {
        if (!isEdit) {
            setAutomatic(e.target.checked);
            let event = {
                target: {
                    name: "isAutomatic",
                    value: e.target.checked
                }
            };
            onChange(event);
        }
    };

    const hasCondition = () => {
        if (typeId === 7 || typeId === 25 || typeId === 26 || typeId === 30)
            return true;
        return false;
    };

    const handleChange = (e) => {
        onRadioChange && onRadioChange(e.target.value);
    };

    const handleSelectFile = (name) => {
        setFileName(name);
    };


    return (
        <React.Fragment>
            <div className={classes.firstRow}>
                <div className={classes.row}>
                    <TextField
                        className={classes.textfield}
                        label={t.reportName}
                        InputLabelProps={{
                            classes: { root: classes.label }
                        }}
                        name="nazwa"
                        value={inputName}
                        onChange={(e) => setName(e.target.value)}
                        onBlur={onChange}
                    />
                    <TextField
                        className={classes.textfield}
                        label={t.fileName}
                        InputLabelProps={{
                            classes: { root: classes.label }
                        }}
                        name="nazwa_pliku"
                        value={inputFilename}
                        onChange={(e) => setFilename(e.target.value)}
                        onBlur={onChange}
                    />
                </div>
                {
                    isEdit ?
                        <div className={classes.endRow}>
                            <ButtonGroup variant="contained" color="primary">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onEmailsEdit}
                                    classes={{ label: classes.buttonLabel }}
                                >
                                    {t.emailList}
                                </Button>
                                {hasCondition() ?
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setSelectedTypeId(typeId)}
                                        classes={{ label: classes.buttonLabel }}
                                    >
                                        {t.conditions}
                                    </Button>
                                    : null}
                            </ButtonGroup>
                        </div>
                        :
                        <React.Fragment>
                            {withDrivers ?
                                <FormControl component="div" className={classes.radioSpacing}>
                                    <FormLabel component="div" className={classes.radioText}>Wybierz</FormLabel>
                                    <RadioGroup row aria-label="type" name="type" value={option} onChange={handleChange}>
                                        <FormControlLabel value={1} control={<Radio className={classes.radio} />} label={t.drivers} />
                                        <FormControlLabel value={3} control={<Radio className={classes.radio} />} label={t.allDrivers} />
                                    </RadioGroup>
                                </FormControl>
                                : null}
                            {withCars ?
                                <FormControl component="div" className={classes.radioSpacing}>
                                    <FormLabel component="div" className={classes.radioText}>Wybierz</FormLabel>
                                    <RadioGroup row aria-label="type" name="type" value={option} onChange={handleChange}>
                                        <FormControlLabel value={1} control={<Radio className={classes.radio} />} label={t.cars} />
                                        <FormControlLabel value={2} control={<Radio className={classes.radio} />} label={t.groups} />
                                        <FormControlLabel value={3} control={<Radio className={classes.radio} />} label={t.allCars} />
                                    </RadioGroup>
                                </FormControl>
                                : null}
                        </React.Fragment>
                }
            </div>
            <div className={classes.row}>
                {isNew
                    &&
                    <TimePeriodPicker
                        disabled={isAutomatic}
                        startDate={startTime}
                        endDate={endTime}
                        onChange={onChange}
                    />
                }
                {
                    (autoEnable && isNew)
                    &&
                    <div className={classes.automaticSwitch}>
                        <CustomSwitch
                            checked={isAutomatic}
                            onChange={handleAutomaticChange}
                        />
                        <Typography variant="body1">
                            {t.automatic}
                        </Typography>
                    </div>
                }
                {
                    autoEnable
                    &&
                    <FormControl className={classes.selectFormControl}>
                        <InputLabel
                            shrink={true}
                            classes={{ root: classes.label }}
                            style={{ color: !isAutomatic ? "#b9b9b9" : "inherit" }}
                        >
                            {t.automaticReportInCycle}
                        </InputLabel>
                        <Select
                            name="cykl"
                            value={cycle}
                            onChange={onChange}
                            disabled={!isAutomatic}
                            classes={{ select: classes.select }}
                            defaultValue={0}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                        >
                            {options.map(option => <MenuItem key={option.key} value={option.value}>{option.key}</MenuItem>)}
                        </Select>
                    </FormControl>
                }
                {isNew ? hasCondition() ?
                    <div className={classes.newReportConditions}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setSelectedTypeId(typeId)}
                            classes={{ label: classes.buttonLabel }}
                        >
                            {t.conditions}
                        </Button>
                    </div>
                    : null
                    : null}

                {withDrivers && !isNew ?
                    <FormControl component="div" className={classes.radioSpacing}>
                        <FormLabel component="div" className={classes.radioText}>Wybierz</FormLabel>
                        <RadioGroup row aria-label="type" name="type" value={option} onChange={handleChange}>
                            <FormControlLabel value={1} control={<Radio className={classes.radio} />} label={t.drivers} />
                            <FormControlLabel value={3} control={<Radio className={classes.radio} />} label={t.allDrivers} />
                        </RadioGroup>
                    </FormControl>
                    : null}

                {withCars && !isNew ?
                    <FormControl component="div" className={classes.radioSpacing}>
                        <FormLabel component="div" className={classes.radioText}>Wybierz</FormLabel>
                        <RadioGroup row aria-label="type" name="type" value={option} onChange={handleChange}>
                            <FormControlLabel value={1} control={<Radio className={classes.radio} />} label={t.cars} />
                            <FormControlLabel value={2} control={<Radio className={classes.radio} />} label={t.groups} />
                            <FormControlLabel value={3} control={<Radio className={classes.radio} />} label={t.allCars} />
                        </RadioGroup>
                    </FormControl>
                    : null}
            </div>
            <ConditionsDialog
                open={selectedTypeId !== null}
                onClose={() => setSelectedTypeId(null)}
                startTime={startTimeCondition}
                endTime={endTimeCondition}
                kilometersLimit={kilometersLimitCondition}
                onSubmit25TypeId={onSubmit25TypeId}
                onSubmit26TypeId={onSubmit26TypeId}
                onSubmit30TypeId={onSubmit30TypeId}
                onSubmit7TypeId={onSubmit7TypeId}
                typeId={selectedTypeId}
                onSelectFile={handleSelectFile}
                fileName={fileName}
            />
        </React.Fragment>
    );
};

ReportDetails.propTypes = {
    classes: PropTypes.object,
    autoEnable: PropTypes.bool,
    reportName: PropTypes.string,
    reportFilename: PropTypes.string,
    typeId: PropTypes.number,
    cycle: PropTypes.number,
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    reportConditions: PropTypes.string,
    onChange: PropTypes.func,
    isEdit: PropTypes.bool,
    onEmailsEdit: PropTypes.func,
    allCarsChecked: PropTypes.bool,
    checkedOption: PropTypes.number,
    onRadioChange: PropTypes.func,
    withCars: PropTypes.bool,
    withDrivers: PropTypes.bool,
    isNew: PropTypes.bool,
    onSubmit7TypeId: PropTypes.func,
    onSubmit25TypeId: PropTypes.func,
    onSubmit26TypeId: PropTypes.func,
    onSubmit30TypeId: PropTypes.func,
};

export default withStyles(useStyles)(ReportDetails);
